import { getTimeTillEndOfDayMs } from '@helpers';
import { queryOptions, useQuery } from '@tanstack/react-query';
import {
  fetchPublicListEntities,
  fetchPublicLists,
} from '@terminal/services/watchlist/watchlist';

export const QUERY_KEY_PUBLIC_LISTS = 'QUERY_KEY_PUBLIC_LISTS';
export const QUERY_PUBLIC_LIST_ENTITIES = 'QUERY_PUBLIC_LIST_ENTITIES';

export const createPublicListsQueryOptions = () =>
  queryOptions({
    queryKey: [QUERY_KEY_PUBLIC_LISTS],
    queryFn: fetchPublicLists,
    staleTime: getTimeTillEndOfDayMs(),
  });

export const createPublicListEntitiesQueryOptions = (listId: string) =>
  queryOptions({
    queryKey: [QUERY_PUBLIC_LIST_ENTITIES, listId],
    queryFn: ({ signal }) => fetchPublicListEntities({ signal, listId }),
    staleTime: getTimeTillEndOfDayMs(),
  });

export const usePublicLists = () => useQuery(createPublicListsQueryOptions());
